import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class ContactContainer extends Vue {
  get lblSetting() {
    return { ...require('../../locales/contact').default }
  }
}

export default ContactContainer;


// WEBPACK FOOTER //
// ./src/containers/contact/index.ts